import { useLocation, matchPath } from 'react-router-dom';

const pageTitles = {
    // Auth pages
    '/login': 'Login',
    '/forgot-password': 'Forgot Password',
    '/reset-password/:token': 'Reset Password',

    // Common pages
    '/companySelect': 'Select Company',
    '/access-denied': 'Access Denied',
    '/404': 'Page Not Found',

    // Dashboard pages
    '/dashboard': 'Dashboard',
    '/client/dashboard': 'Dashboard',

    // Account pages
    '/account': 'User Profile',
    '/account/update/:id': 'Update User Profile',

    // Positions pages
    '/positions': 'List Positions',
    '/positions/add': 'Add Position',
    '/positions/:id': 'View Position',
    '/positions/modify/:id': 'Modify Position',
    '/positions/bulk-modify': 'Bulk Modify Positions',
    '/positions/bulk-modify/preview': 'Bulk Modify Positions Preview',

    // Client HQ Positions
    '/client/positions': 'Positions',
    '/client/positions/create-position': 'Create Position',
    '/client/positions/bulk-upload': 'Bulk Upload Positions',
    '/client/positions/details': 'Position Details',

    // Change Requests pages
    '/changerequests': 'List Change Requests',
    '/changeRequests/:id': 'View Change Request',
    '/changeRequests/create/:positionId': 'Create Change Request',
    '/changeRequests/:id/modify/:positionId': 'Modify Change Request',
    '/changeRequests/bulk/create': 'Bulk Create Change Requests',
    '/changeRequests/bulk/modify': 'Bulk Modify Change Requests',

    // Change Request Policies pages
    '/changerequest/crpolicies': 'List CR Policies',
    '/changerequest/crpolicies/add': 'Add CR Policy',
    '/changerequest/crpolicies/view/:id': 'View CR Policy',
    '/changerequest/crpolicies/modify/:id': 'Modify CR Policy',
    '/changerequest/crpolicies/mappedpositions/view/:crPolicyId': 'View Mapped Positions',
    '/changerequest/crpolicies/mappedpositions/update/:crPolicyId': 'Update Mapped Positions',

    // Change Request Policies pages
    '/client/reviewrequest/reviewpolicies': 'List Review Policies',
    '/client/reviewrequest/reviewpolicies/add': 'Add Review Policy',
    '/client/reviewrequest/reviewpolicies/view/:id': 'View Review Policy',
    '/client/reviewrequest/reviewpolicies/modify/:id': 'Modify Review Policy',
    '/client/reviewrequest/reviewpolicies/mappedpositions/view/:crPolicyId': 'View Mapped Positions',
    '/client/reviewrequest/reviewpolicies/mappedpositions/update/:crPolicyId': 'Update Mapped Positions',

    // Recruitment Policies pages
    '/recruitmentPolicies': 'List Recruitment Policies',
    '/recruitmentPolicies/:id': 'View Recruitment Policy',

    // Users pages
    '/users': 'List Users',
    '/users/add': 'Add User',
    '/users/edit/:id': 'Edit User',
    '/users/:id': 'View User',

    // Company pages
    '/company': 'List Companies',
    '/company/add': 'Add Company',
    '/company/edit/:id': 'Edit Company',
    '/company/:id': 'View Company',
    '/company/:companyId/config': 'Company Configuration',

    // Master Custom Attributes
    '/masterCustomAttributes': 'Master Custom Attributes',

    // Settings pages
    '/settings/roles': 'List Roles',
    '/settings/roles/add': 'Add Role',
    '/settings/roles/edit/:id': 'Edit Role',
    '/settings/roles/:id': 'View Role',

    '/settings/locations': 'List Locations',
    '/settings/locations/add': 'Add Location',
    '/settings/locations/edit/:id': 'Edit Location',
    '/settings/locations/:id': 'View Location',

    '/settings/designations': 'List Designations',
    '/settings/designations/add': 'Add Designation',
    '/settings/designations/edit/:id': 'Edit Designation',
    '/settings/designations/:id': 'View Designation',

    '/settings/departments': 'List Departments',
    '/settings/departments/add': 'Add Department',
    '/settings/departments/edit/:id': 'Edit Department',
    '/settings/departments/:id': 'View Department',

    '/settings/demand-attributes': 'Demand Attributes',

    '/settings/change-policy/roles': 'Change Policy Roles',

    '/settings/recruitment-policy/attributes': 'Recruitment Policy Attributes',

    '/settings/modify-position-external-ids': 'Modify Position External IDs',

    '/settings/upload-position-data': 'Upload Position Data',

    '/settings/update-integration': 'Update Integration',

    '/settings/request-maps': 'Request Maps',

    '/settings/system-permissions': 'System Permissions',
};

export const usePageTitles = () => {
    const location = useLocation();

    const currentPageTitle = Object.keys(pageTitles).find((key) => {
        if (matchPath({ path: key, exact: true }, location.pathname)) {
            return true;
        }
        return false;
    });

    return pageTitles[currentPageTitle];
};
